/*
 * @Author: Chris 
 * @Date: 2022-08-29 16:54:31 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-09-30 14:16:48
 */
 
<template>
  <el-drawer
    size="25%"
    :modal="false"
    :before-close="closeDrawer"
    :visible.sync="this.$store.state.Drawer_Department_Add"
    :with-header="false"
  >
    <CardHeader :name="headerName" @closeDrawer="closeDrawer"></CardHeader>
    <div class="addRole">
      <el-form class="form_" ref="form" :model="form" label-width="80px">
        <el-form-item label="部门名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <div class="addbutton">
          <el-button type="primary" @click="onSubmit"> 添 加 </el-button>
        </div>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
import { authdeptaddSub } from "../../../api/api";
import CardHeader from "../../../components/cardHeader/index.vue";
export default {
  name: "addRole",
  props: ["deptId"],
  components: { CardHeader },
  data() {
    return {
      headerName: "添加子部门",
      form: { name: "" },
    };
  },
  methods: {
    onSubmit() {
      if (this.form.name) {
        let params = {
          deptPid: this.$props.deptId,
          deptName: this.form.name,
        };
        authdeptaddSub(params).then((res) => {
          if (res.code == 200) {
            this.$store.commit("SET_Refresh_Organize");
            this.closeDrawer();
          }
        });
      }
    },

    /**
     * 关闭
     * */

    closeDrawer() {
      this.form.name = "";
      this.$store.commit("SET_Drawer_Department_Add", false);
    },
  },
};
</script>

<style lang="scss" scoped>
.addRole {
  padding: 0.75rem;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  .form_ {
    margin-top: 1.25rem;
    width: 75%;
  }
  .addbutton {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>